module.exports = __webpack_public_path__ + "img/selected4-min.5634b9fa.png";